/**
 * Computer object
 */
Game.Prefabs.Computer = function( game, x, y, group, properties ) {

	// Setup computer.
	Phaser.Sprite.call( this, game, x + Game.Utils.Map.TILE_HALF_SIZE, y, 'terminal' );

	// Add computer animations.
	this.animations.add( 'blink', [ 0, 1 ], 2, true );

	console.log( 'new computer' );

	// Set the anchor to the middle to center the computer on the tile.
	this.anchor.setTo( 0.5, 0 );

	// Play the spin animation by default.
	this.animations.play( 'blink' );

	this.computerProperties = properties;


	Game.Utils.Map.add_zone(
		{
			type: 'computer',
			x: x - Game.Utils.Map.TILE_HALF_SIZE,
			y: y,
			width: Game.Utils.Map.TILE_SIZE * 2,
			height: Game.Utils.Map.TILE_SIZE * 2,
			name: properties.name,
		}
	);


	// Add to the display group.
	group.add( this );

};


Game.Prefabs.Computer.prototype = Object.create( Phaser.Sprite.prototype );


Game.Prefabs.Computer.constructor = Game.Prefabs.Computer;
